




























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import ImportPage from "@/lib/import-page";
import { mixins } from "vue-class-component";

@Component({
  components: {},
})
export default class ImportTransport extends mixins(ImportPage, AbpBase) {
  importPageName = "Transport";
  //filters
  current: number = 0;
  transportFileId: number = 0;
  spinShow: boolean = false;

  get store() {
    return this.$store.state.transportImport;
  }
  get countItems() {
    return this.$store.state.transportImport.countItems;
  }
  get countImportedItems() {
    return this.$store.state.transportImport.countImportedItems;
  }
  get list() {
    return this.$store.state.transportImport.itemsImported;
  }
  get loading() {
    return this.$store.state.productImport.loading;
  }
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }
  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "transportImport/export",
      data: this.transportFileId,
    });
  }
  renderErrorMsgElements(errorMessage: string) {
    return Util.renderErrorMsgElements(errorMessage);
  }
  columns = [
    {
      title: this.L("ErrorMsg"),
      width: 200,
      fixed: "left",
      slot: "errorMessage",
    },
    {
      title: this.L("Code"),
      width: 200,
      key: "transportCode",
    },
    {
      title: this.L("Type"),
      width: 100,
      key: "transportType",
    },
    {
      title: this.L("NumOfSlot"),
      width: 100,
      key: "numOfSlot",
      align: "right",
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.numOfSlot));
      },
    },
    {
      title: this.L("MaxProductSizeCode"),
      width: 100,
      key: "maxProductSizeCode",
    },
    {
      title: this.L("ParentCode"),
      width: 200,
      key: "parentCode",
    },
    {
      title: this.L("IsImported"),
      width: 80,
      fixed: "right",
      key: "isImported",
      align: "center",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: params.row.isImported
                  ? "md-checkmark-circle"
                  : "md-close-circle",
              },
            },
            ""
          ),
        ]);
      },
    },
  ];

  created() {
    if (!this.checkSignalConnected()) return;
    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.Transport", (notification) => {
        this.processNotifierImportTransport(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.Transport", (notification) => {
          this.processNotifierImportTransport(notification);
        });
      });
    }
  }

  processNotifierImportTransport(notification: any) {
    if (
      !Util.isNull(notification.transportFileId) &&
      notification.transportFileId == this.transportFileId
    ) {
      this.$store.commit({
        type: "transportImport/processNotifier",
        data: notification,
      });
    }
  }
  resetList() {
    this.$store.commit({
      type: "transportImport/resetList",
    });
  }

  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      this.spinShow = true;
      try {
        this.$store
          .dispatch("transportImport/uploadImportTransportFile", data)
          .then((res) => {
            this.resetList();
            this.activeStep(true);
            this.transportFileId = res;
            this.spinShow = false;
          })
          .catch(() => {
            this.spinShow = false;
          });
      } catch (error) {
        this.spinShow = false;
      }
    }
    return false;
  }
}
